import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { applyRouteMetadata } from './metadata'

export default function RouteMetadata() {
  const { pathname } = useLocation()
  useEffect(() => applyRouteMetadata(pathname), [pathname])
  return null
}
